import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import TopicHeroStore from './store';

const styles = require('./index.less');

const TopicHero = ({ store, content = false }) => (
  <header className={cx(styles.root, { [styles.content]: content })} aria-label="云水相逢，9月24日资料片上线">
    <div className={styles.background} data-name="bg" />
    {!content && (
      <nav className={styles.tags} aria-label="资料片玩法" data-name="小tag">
        {store.items.map(item => (
          <a
            key={item.key}
            className={styles.tag}
            data-name={item.title}
            href={item.href}
            target={item.target}
            rel={item.rel}
            onClick={item.onClick}
            aria-disabled={item.disabled || undefined}
          >
            <img src={require(`./images/tag-${item.key}.png`)} alt={item.title} />
          </a>
        ))}
      </nav>
    )}
    <div className={styles.logos} data-name="logo">
      <a className={styles.jx2Logo} href="https://jx2.xoyo.com/" target="_blank" rel="noopener" aria-label="剑网2官网">
        <img src={require('./images/logo-jx2.png')} alt="剑侠情缘Online II" />
      </a>
      <a className={styles.jwLogo} href="https://jw.xoyo.com/" target="_blank" rel="noopener" aria-label="剑侠贰外传官网">
        <img src={require('./images/logo-jw.png')} alt="剑侠贰外传" />
      </a>
    </div>
  </header>
);

export default wrapStore(TopicHero, TopicHeroStore);
